import { Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { CulturalLeadershipFrameworkAuthService } from "@org-common/lib/cultural-leadership/cultural-leadership-framework-auth.service";
import { CulturalDataFilterParamKeys } from "../../cultural-data-filter";
import { CulturalIndexAnalysisFilter } from "../cultural-index-analysis-filter";
import { CulturalIndexAuthService } from "../cultural-index-auth.service";
import { CulturalIndexFilterService } from "../cultural-index-filter/cultural-index-filter.service";

@Component({
    selector: "adapt-ci-orbit-page",
    templateUrl: "./ci-orbit-page.component.html",
    standalone: false,
})
export class CulturalIndexOrbitPageComponent extends BaseRoutedComponent implements OnInit {
    public readonly CareerValuationFilterParamKeys = Object.values(CulturalDataFilterParamKeys);

    public canSeeData = false;
    public showComparison = false;

    public filterParameters = CulturalIndexAnalysisFilter.getDefaultFilterParameters();

    public constructor(
        public filterService: CulturalIndexFilterService,
        private culturalIndexAuthService: CulturalIndexAuthService,
        injector: Injector,
        private clfAuthService: CulturalLeadershipFrameworkAuthService,
    ) {
        super(injector);

        this.filterService.reset();
    }

    public async ngOnInit() {
        this.canSeeData = this.culturalIndexAuthService.currentPersonHasAtLeastQuantitativeAccess()
            || await this.clfAuthService.currentPersonIsCulturalLeader();
        this.notifyActivated();
    }
}
